document.addEventListener("DOMContentLoaded", function () {
  const lis = document.querySelectorAll(".grid__item_features[open]");

  // 创建模态框覆盖层
  const modalOverlay = document.createElement("div");
  modalOverlay.className = "modal-overlay";

  // 创建模态框内容
  const modalContent = document.createElement("div");
  modalContent.className = "modal-content";

  // 为每个LI标签添加点击事件监听器
  lis.forEach((li) => {
    li.addEventListener("click", function () {
      // 设置模态框内容
      modalContent.innerHTML = li.innerHTML;

      // 添加模态框到覆盖层
      modalOverlay.appendChild(modalContent);

      // 显示覆盖层
      document.body.appendChild(modalOverlay);
      modalOverlay.style.display = "flex";

      // 点击覆盖层关闭模态框
      modalOverlay.addEventListener("click", function () {
        modalOverlay.style.display = "none";
        modalOverlay.removeChild(modalContent);
        document.body.removeChild(modalOverlay);
      });
    });
  });
});
